import { IFilterSelection } from '@studyportals/search-page-interface';

export class FilterPersistenceValue {
	public readonly version: string;
	public readonly filters: IFilterSelection;

	public constructor(version: string, filters: IFilterSelection) {
		this.version = version;
		this.filters = filters;
	}

	public static is(value: unknown): value is FilterPersistenceValue {
		return typeof value === 'object' && value !== null && 'version' in value && 'filters' in value;
	}
}
